(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/use-fetch-date.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/use-fetch-date.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ReactRouterDOM = ReactRouterDOM,
  useParams = _ReactRouterDOM.useParams;
const tipsenApi = svs.components.tipsen.store.tipsenApi;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectDrawProductIds = svs.components.tipsen.engine.selectors.engineSelectors.selectDrawProductIds;
const useFetchDate = () => {
  var _svs$tipsen, _svs$tipsen2, _data$results;
  const productId = useSelector(selectDrawProductIds)[0];
  const hasServerLoadedDate = Boolean((_svs$tipsen = svs.tipsen) === null || _svs$tipsen === void 0 || (_svs$tipsen = _svs$tipsen.data) === null || _svs$tipsen === void 0 ? void 0 : _svs$tipsen.latestResultDate);
  let noParamFetchDate = hasServerLoadedDate ? new Date((_svs$tipsen2 = svs.tipsen) === null || _svs$tipsen2 === void 0 || (_svs$tipsen2 = _svs$tipsen2.data) === null || _svs$tipsen2 === void 0 ? void 0 : _svs$tipsen2.latestResultDate) : new Date();

  const _tipsenApi$useGetDraw = tipsenApi.useGetDrawsResultsQuery({
      productId
    }, {
      skip: hasServerLoadedDate || !productId
    }),
    data = _tipsenApi$useGetDraw.data,
    error = _tipsenApi$useGetDraw.error;

  let noDrawsDateAvailable = false;
  if (!hasServerLoadedDate && (error === null || error === void 0 ? void 0 : error.status) === 404) {
    noDrawsDateAvailable = true;
  } else if (data !== null && data !== void 0 && (_data$results = data.results) !== null && _data$results !== void 0 && _data$results.length && !error) {
    const _data$results2 = _slicedToArray(data.results, 1),
      firsResult = _data$results2[0];
    noParamFetchDate = new Date(firsResult.regCloseTime);
  }
  const _useParams = useParams(),
    dateParam = _useParams.date;
  const hasDateParam = Boolean(dateParam);
  let fetchDate;
  let currentDate;
  if (dateParam) {
    const _dateParam$split = dateParam.split('-'),
      _dateParam$split2 = _slicedToArray(_dateParam$split, 3),
      year = _dateParam$split2[0],
      month = _dateParam$split2[1],
      day = _dateParam$split2[2];
    fetchDate = {
      day: parseInt(day, 10),
      month: parseInt(month, 10),
      year: parseInt(year, 10)
    };
    currentDate = new Date(dateParam);
  } else {
    fetchDate = {
      day: noParamFetchDate.getDate(),
      month: noParamFetchDate.getMonth() + 1,
      year: noParamFetchDate.getFullYear()
    };
    currentDate = noParamFetchDate;
  }
  return [fetchDate, currentDate, hasDateParam, noDrawsDateAvailable];
};
setGlobal('svs.components.tipsen.routeResult.useFetchDate', useFetchDate);

 })(window);